import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-inline-text',
    templateUrl: './inline-text.component.html',
    styleUrls: ['./inline-text.component.scss'],
    standalone: false
})
export class InlineTextComponent implements OnInit {
  @Input() data: string;
  @Input() label: string = "";
  @Input() placeholder: string = "Enter text";
  @Input() disabledFlag: boolean;
  @Input() maxlength: number = 524288;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  editMode: boolean = false;
  tempValue: string = "";

  constructor() {}

  ngOnInit() {
  }

  changeToEdit(event) {
    if( !this.disabledFlag) {
      this.editMode = true;
    }
  }

  onFocusOut(data:string) {
    this.data = data;
    this.editMode = false;
    this.focusOut.emit(this.data);
  }

  startEdit() {
    this.tempValue = this.data;
  }

  undo() {
    this.editMode = false;
    this.data = this.tempValue;
  }
}
